import type { Payload } from './types';

export const DEFAULT_PAYLOAD: Payload = {
	offset: 0,
	viewportWidth: 0,
	scrollWidth: 0,
	scrollElements: [],
};
